import axiosInstanceMock from "./mock/axiosMock";
import axiosInstanceMain from "./axiosInstance";
import { ChatFeedbackRequest, ConnectAgentRequest, FetchChatsRequest, IEscalateL1ManagerTicketRequest, IGetL1ManagerAssignedTicketsRequest, IGetL1ManagerTicketDetailsRequest, IResolveL1ManagerTicketRequest } from "../interfaces/serviceInterfaces";
import { getEnv } from "../utils/envConfig";

const L1_MANAGER_ASSIGNED_TICKETS = '/supportEngineer/fetchAssignedTickets';
const L1_MANAGER_TICKET_DETAILS = '/supportEngineer/getTicketDetails';
const L1_MANAGER_ESCALATE_TICKET = '/supportEngineer/escalateTicket';
const L1_MANAGER_RESOLVE_TICKET = '/supportEngineer/resolveTicket';
const L1_MANAGER_CHAT_FEEDBACK = 'supportEngineer/feedback';
const L1_MANAGER_FETCH_SIMILAR_TICKETS = 'supportEngineer/fetchSimilarTickets';
const L1_MANAGER_MOST_RELEVANT_SOP = 'supportEngineer/mostRelevantSOP';
const L1_MANAGER_AI_AGENT = 'supportEngineer/connectAgent';
const L1_MANAGER_FETCH_CHATS = '/supportEngineer/fetchChats';
const L1_MANAGER_FETCH_CHAT_HISTORY = '/supportEngineer/fetchChatHistory';

//const axiosInstance = axiosInstanceMock;
const axiosInstance = axiosInstanceMain;

const BASE_URL = getEnv('VITE_API_BASE_URL_L1_MANAGER');

export async function getL1ManagerAssignedTickets({
    userId,
    pageSize,
    pageNo,
    appliedFilters
}: IGetL1ManagerAssignedTicketsRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `${L1_MANAGER_ASSIGNED_TICKETS}/${userId}`,
            //url: `${L1_MANAGER_ASSIGNED_TICKETS}`, // for mock 
            params: {
                pageSize,
                pageNo,
                ...appliedFilters
            },
        })
    } catch (error) {
        console.log(error);
    }
};

export async function getL1ManagerTicketDetails({
    ticketId
}: IGetL1ManagerTicketDetailsRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `${L1_MANAGER_TICKET_DETAILS}/${ticketId}`,
            //url: `${L1_MANAGER_TICKET_DETAILS}`, // for mock
        })
    } catch (error) {
        console.log(error);
    }
};

export async function getL1ManagerSimilarTickets({
    userId,
    description,
    pageSize,
    pageNo
}: any) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `${L1_MANAGER_FETCH_SIMILAR_TICKETS}`,
            params: {
                description: description,
                user_id: userId,
                pageSize,
                pageNo,
                sortColumn: 'createdAt',
                sortOrder: 'desc'
            }
        })
    } catch (error) {
        console.log(error);
    }
};

export async function getL1ManagerMostRelevantSOP({
    description,
    userId
}: any) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `${L1_MANAGER_MOST_RELEVANT_SOP}?description=${description}&userId=${userId}`
        })
    } catch (error) {
        console.log(error);
    }
};

export async function resolveL1ManagerAssignedTicket({
    ticketId,
    resolutionNotes
}: IResolveL1ManagerTicketRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'POST',
            url: `${L1_MANAGER_RESOLVE_TICKET}`,
            //url: `${L1_MANAGER_TICKET_DETAILS}`, // for mock
            data: {
                ticket_id: ticketId,
                resolution_notes: resolutionNotes
            }
        })
    } catch (error) {
        console.log(error);
    }
};

export async function escalateL1ManagerAssignedTicket({
    ticketId,
    escalation_reason
}: IEscalateL1ManagerTicketRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'POST',
            url: `${L1_MANAGER_ESCALATE_TICKET}`,
            //url: `${L1_MANAGER_TICKET_DETAILS}`, // for mock
            data: {
                ticket_id: ticketId,
                escalation_reason: escalation_reason
            }
        })
    } catch (error) {
        console.log(error);
    }
};

export async function fetchChats({
    user_id,
    pageSize,
    pageNo,
    appliedFilters
}: FetchChatsRequest & { user_id: string; pageSize: number; pageNo: number }) {
    try {
        const params: Record<string, any> = {
            pageSize,
            pageNo,
        };

        if (appliedFilters?.search_text) {
            params.search_text = appliedFilters.search_text;
        }

        if (appliedFilters?.search_column) {
            params.search_column = appliedFilters.search_column;
        }
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `${L1_MANAGER_FETCH_CHATS}/${user_id}`,
            params
        });
    } catch (error) {
        console.log(error);
    }
}

export async function fetchChatHistory({
    thread_id,
}: any) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `${L1_MANAGER_FETCH_CHAT_HISTORY}/${thread_id}`,
        })
    } catch (error) {
        console.log(error);
    }
}

export async function connectAgent({
    prompt,
    user_id
}: ConnectAgentRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'POST',
            url: `${L1_MANAGER_AI_AGENT}`,
            data: {
                prompt,
                user_id
            }
        })
    } catch (error) {
        console.log(error);
    }
}

export async function sendChatFeedback({
    chatId,
    messageId,
    userId,
    like,
    dislike,
    comment,
    traceId
}: ChatFeedbackRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'POST',
            url: `${L1_MANAGER_CHAT_FEEDBACK}`,
            data: {
                chat_id: chatId,
                message_id: messageId,
                user_id: userId,
                like,
                dislike,
                feedbackComments: comment,
                trace_id: traceId
            }
        })
    } catch (error) {
        console.log(error);
    }
}

export async function getChatFeedback({
    chatId
}: ChatFeedbackRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `${L1_MANAGER_CHAT_FEEDBACK}/${chatId}`
        })
    } catch (error) {
        console.log(error);
    }
}